import { render, staticRenderFns } from "./EventDrawer.vue?vue&type=template&id=31fd080e&scoped=true&"
import script from "./EventDrawer.vue?vue&type=script&lang=js&"
export * from "./EventDrawer.vue?vue&type=script&lang=js&"
import style0 from "./EventDrawer.vue?vue&type=style&index=0&id=31fd080e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd080e",
  null
  
)

export default component.exports